import { render, staticRenderFns } from "./HolidayPlusMenu.vue?vue&type=template&id=12f72c4a&scoped=true"
import script from "./HolidayPlusMenu.vue?vue&type=script&lang=js"
export * from "./HolidayPlusMenu.vue?vue&type=script&lang=js"
import style0 from "./HolidayPlusMenu.vue?vue&type=style&index=0&id=12f72c4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f72c4a",
  null
  
)

export default component.exports